Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedFilterView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/applied_filter"]

  humanize: false
  allowRemove: true
  hasLogicSelector: false
  unmodifiableByModerators: false

  events:
    'click a.remove': 'apply'
    'click a.clearFilter': 'clear'
    'click input.logic-selector': 'onLogicChange'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @tagsByClientCode = @options.tagsByClientCode

  getDescription: (value) ->
    return value

  getValue: (value) ->
    if typeof value is 'string' then value else value.text

  getAppliedValues: ->
    value = @searchQuery.get(@name)
    if typeof value is 'string' then [value] else value

  destroy: ->
    this.remove()
    return false

  render: ->
    @$el.html(@template(self: @))
    @allowClearFilter() unless @unmodifiableByModerators
    return this

  apply: (event) =>
    @removeFilter($(event.target).data('value') || $(event.target).parent().find('.hidden_value').text())
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  clear: =>
    @searchQuery.resetField(@name)
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  isLogicSelected: (value) ->
    if not @searchQuery.get("#{@name}_logic")
      @searchQuery.set("#{@name}_logic", 'OR')
    @searchQuery.get("#{@name}_logic") == value

  onLogicChange: (event) =>
    logicSelected = $(event.target).val()
    @searchQuery.set("#{@name}_logic", logicSelected)
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  allowClearFilter: ->
    @$el.find('a.remove, a.remove-filters').attr('style', 'display: inline')

  _filterName: ->
    I18n.t(
      "monitoring.dashboard.filters.filter_names.#{@name}"
      defaultValue: @alias or _.str.capitalize(@name)
    )

  inMyHistorySession: ->
    $('li.active a span #name').text() == 'My History'

  appliedTopics: =>
    appliedTopics = _.map(@getAppliedValues(), (value) => {value: value, icon: @iconForSource(value.provider) } )
    sortedTopics = _.sortBy(appliedTopics, (topic) -> topic.name)

  iconForSource: (source) =>
    (new Monitoring.Models.SourceIcon).sourceIcon(source)
